// extracted by mini-css-extract-plugin
export default {"title":"retrieve_title__O+x57","count":"retrieve_count__UNkDQ"};